(function () {
  'use strict';

  /**
   * Convert an ISO 3166-1 alpha-2 code to its emoji flag.
   * Works by offsetting each letter into the Regional Indicator Symbol range.
   */
  function isoToFlag(code) {
    if (!code || code.length !== 2) return '';
    var offset = 0x1F1E6 - 65; // 'A' = 65
    var first = code.codePointAt(0);
    var second = code.codePointAt(1);
    return String.fromCodePoint(first + offset) + String.fromCodePoint(second + offset);
  }

  var root = document.querySelector('.cs');
  if (!root) return;

  var trigger = root.querySelector('.cs__trigger');
  var panel = root.querySelector('.cs__panel');
  var search = root.querySelector('.cs__search');
  var list = root.querySelector('.cs__list');
  var flagEl = root.querySelector('.cs__flag');
  var labelEl = root.querySelector('.cs__label');
  var countryInput = root.querySelector('.cs__country-input');
  var locForm = root.querySelector('.cs__loc-form');
  var languageInput = locForm.querySelector('[name="language_code"]');
  var feedback = root.querySelector('.cs__feedback');
  var submitting = false;
  var submitTimer;
  var focusTimer;
  var closeButton = root.querySelector('.cs__close');
  // form.reset() does not restore hidden inputs (their value is the default), so
  // keep the rendered preferences to undo a submission that never navigated.
  var initialCountry = countryInput.value;
  var initialLanguage = languageInput.value;
  function restoreInputs() {
    countryInput.value = initialCountry;
    languageInput.value = initialLanguage;
  }

  function submitPreferences() {
    if (submitting) return;
    submitting = true;
    panel.setAttribute('aria-busy', 'true');
    if (feedback) { feedback.hidden = false; feedback.textContent = feedback.dataset.busy; }
    var returnInput = locForm.querySelector('[name="return_to"]');
    if (returnInput) returnInput.value = window.location.pathname + window.location.search + window.location.hash;
    try { locForm.submit(); } catch (_) { recover(); return; }
    submitTimer = setTimeout(recover, 12000);
  }

  function recover() {
    submitting = false;
    locForm.reset();
    restoreInputs();
    selectedCode = countryInput.value;
    labelEl.textContent = selectedCode;
    flagEl.textContent = isoToFlag(selectedCode);
    root.dataset.selected = selectedCode;
    render();
    open();
    panel.removeAttribute('aria-busy');
    if (feedback) { feedback.hidden = false; feedback.textContent = feedback.dataset.error; }
  }

  root.querySelectorAll('.cs__language').forEach(function (button) {
    button.addEventListener('click', function () {
      if (submitting) return;
      if (button.dataset.language === languageInput.value) { close(); trigger.focus(); return; }
      languageInput.value = button.dataset.language;
      submitPreferences();
    });
  });
  window.addEventListener('pageshow', function () {
    clearTimeout(submitTimer);
    submitting = false;
    panel.removeAttribute('aria-busy');
    if (feedback) feedback.hidden = true;
    locForm.reset();
    restoreInputs();
  });

  // Country data injected by Liquid as a JSON script block
  var countries = [];
  try {
    var dataEl = document.getElementById('avora-cs-data');
    if (dataEl) countries = JSON.parse(dataEl.textContent);
  } catch (e) { /* silent */ }

  // Priority destinations first; keep all other Shopify countries alphabetized in the active language.
  var priorityCountries = ['US', 'CA', 'GB', 'FR', 'DE', 'BE', 'ES', 'IT', 'AU', 'NL', 'CH', 'AT', 'IE', 'PT', 'SE', 'DK', 'NO', 'FI', 'PL', 'CZ', 'GR'];
  var countryCollator = new Intl.Collator(document.documentElement.lang || 'en', { sensitivity: 'base' });
  countries.sort(function (a, b) {
    var aRank = priorityCountries.indexOf(a.code);
    var bRank = priorityCountries.indexOf(b.code);
    if (aRank !== -1 || bRank !== -1) return (aRank === -1 ? priorityCountries.length : aRank) - (bRank === -1 ? priorityCountries.length : bRank);
    return countryCollator.compare(a.name, b.name);
  });

  var selectedCode = root.dataset.selected || '';

  function render() {
    list.innerHTML = '';
    countries.forEach(function (c) {
      var li = document.createElement('li');
      li.className = 'cs__option';
      li.setAttribute('role', 'option');
      li.setAttribute('aria-selected', c.code === selectedCode);
      li.tabIndex = c.code === selectedCode ? 0 : -1;
      li.dataset.code = c.code;
      li.dataset.name = c.name.toLowerCase();
      li.innerHTML =
        '<span class="cs__option-flag">' + isoToFlag(c.code) + '</span>' +
        '<span class="cs__option-name">' + c.name + '</span>';
      li.addEventListener('click', function () { select(c); });
      list.appendChild(li);
    });
  }

  function select(country) {
    if (submitting) return;
    selectedCode = country.code;
    flagEl.textContent = isoToFlag(country.code);
    labelEl.textContent = country.code;
    root.dataset.selected = country.code;

    list.querySelectorAll('.cs__option').forEach(function (li) {
      li.setAttribute('aria-selected', li.dataset.code === country.code);
    });

    close();

    try { localStorage.setItem('avora-country-autodetected', 'manual:' + country.code); } catch (e) {}

    // Submit Shopify localization form
    if (countryInput && locForm) {
      countryInput.value = country.code;
      submitPreferences();
    }
  }

  function open() {
    panel.removeAttribute('inert');
    panel.setAttribute('aria-hidden', 'false');
    panel.classList.add('is-open');
    trigger.setAttribute('aria-expanded', 'true');
    search.value = '';
    filter('');
    clearTimeout(focusTimer);
    focusTimer = setTimeout(function () {
      // Keep the phone keyboard closed until the shopper chooses to search.
      var mobile = window.matchMedia && window.matchMedia('(max-width: 749px)').matches;
      (mobile && closeButton ? closeButton : search).focus();
    }, 50);
  }

  function visibleOptions() {
    return Array.from(list.querySelectorAll('.cs__option:not(.is-hidden)'));
  }

  function focusOption(option) {
    if (!option) return;
    list.querySelectorAll('.cs__option').forEach(function (item) { item.tabIndex = item === option ? 0 : -1; });
    option.focus();
  }

  function moveOption(current, direction) {
    var options = visibleOptions();
    if (!options.length) return;
    var index = options.indexOf(current);
    if (direction === 'first') index = 0;
    else if (direction === 'last') index = options.length - 1;
    else index = (Math.max(index, 0) + direction + options.length) % options.length;
    focusOption(options[index]);
  }

  function close() {
    clearTimeout(focusTimer);
    panel.classList.remove('is-open');
    trigger.setAttribute('aria-expanded', 'false');
    panel.setAttribute('aria-hidden', 'true');
    panel.setAttribute('inert', '');
  }

  function filter(query) {
    var q = query.toLowerCase().trim();
    var any = false;

    list.querySelectorAll('.cs__option').forEach(function (li) {
      var match = !q || li.dataset.name.includes(q);
      li.classList.toggle('is-hidden', !match);
      if (match) any = true;
    });

    var empty = list.querySelector('.cs__empty');
    if (!any && !empty) {
      empty = document.createElement('li');
      empty.className = 'cs__empty';
      empty.textContent = window.AvoraI18n ? window.AvoraI18n.text('No countries found') : 'No countries found';
      list.appendChild(empty);
    } else if (any && empty) {
      empty.remove();
    }
  }

  trigger.addEventListener('click', function (e) {
    e.stopPropagation();
    panel.classList.contains('is-open') ? close() : open();
  });

  if (closeButton) closeButton.addEventListener('click', function () { close(); trigger.focus(); });
  // The menu closes its focus trap before handing off to this shared picker.
  document.addEventListener('avora:open-localization', open);

  search.addEventListener('input', function (e) { filter(e.target.value); });
  search.addEventListener('keydown', function (e) {
    if (e.key === 'ArrowDown') {
      e.preventDefault();
      focusOption(visibleOptions()[0]);
    }
  });

  list.addEventListener('keydown', function (e) {
    var option = e.target.closest('.cs__option');
    if (!option) return;
    if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
      e.preventDefault();
      moveOption(option, e.key === 'ArrowDown' ? 1 : -1);
    } else if (e.key === 'Home' || e.key === 'End') {
      e.preventDefault();
      moveOption(option, e.key === 'Home' ? 'first' : 'last');
    } else if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      var country = countries.find(function (item) { return item.code === option.dataset.code; });
      if (country) select(country);
    }
  });

  document.addEventListener('click', function (e) {
    if (!root.contains(e.target)) close();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && panel.classList.contains('is-open')) {
      close();
      trigger.focus();
    }
  });

  render();
})();
